<template><div><h1>VUX V2.3.6 发布日志</h1>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[feature] 支持多个箭头样式变量</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 添加 slot:title</li>
<li>[feature] 添加 prop:readonly</li>
<li>[fix] 修复 scroller 支持数字类型引入的 bug #1406</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[change] render-function 参数 day => date（在 3.0 版本前不会影响目前使用）#1361</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] 添加 prop:readonly</li>
<li>[feature] 添加 slot:icon</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[feature] 添加方法 setBlur</li>
</ul>
<h2><a href="/zh-CN/components/spinner.html">Spinner</a></h2>
<ul><li>[feature] 支持 prop:size #1447</li>
</ul>
<h2><a href="/zh-CN/components/string.html">String</a></h2>
<ul><li>[enhance] 可以直接引用 trim 代替原来的 stringTrim</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.6 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.6-240.vue?a6dd6f20